import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  REPORTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/reports/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_REPORT: ({ commit, dispath }, model) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/reports`, model).then(res => {
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  GET_REPORT_ZIP: ({ commit, dispatch }, reportId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/reports/${reportId}/download/zip`, {responseType: 'blob'}).then(res => {
        resolve(res)
      }, err => {
        reject(err)
      })
    })
  },
  GET_REPORT_FILE: ({ commit, dispatch }, reportId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/reports/${reportId}/download/xlsx`, {responseType: 'blob'}).then(res => {
        resolve(res)
      }, err => {
        reject(err)
      })
    })
  },
  GET_REPORTS_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/reports/info`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_USER_PERMISSIONS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/info`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_REPORTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/reports/delete`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/report/actions.js